import { useLocation } from "react-router-dom";

import { useGetFriendlyUrl } from "./useGetFriendlyUrl";

export const useIsOnProtectedRoute = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const location = useLocation();

  const prefix = `e-rezerwacja/${friendlyUrl}/uzytkownik`;

  const protectedRoutes = [
    `${prefix}/profil`,
    `${prefix}/aktualne-wizyty`,
    `${prefix}/historyczne-wizyty`,
  ];

  return !!protectedRoutes.find((protectedRoute) =>
    location.pathname.includes(protectedRoute)
  );
};
